import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  constructor() {}

  setItem(key: string, value: object | string): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const dataItem = localStorage.getItem(key);

    if (dataItem && dataItem !== 'undefined') {
      return JSON.parse(dataItem);
    } else {
      return null;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
